import { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Container,
  FloatingLabel,
  Form,
  FormControl,
  Alert,
  InputGroup,
  Pagination,
  Col,
  Row,
  Badge,
} from "react-bootstrap";
import ApiService from "../../../services/api";
import "../css/search.css";
import { AuthContext } from "../../../services/auth";

function Search() {
  const { isEnglish } = useContext(AuthContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(12);
  const [indexStart, setIndexStart] = useState(0);
  const [indexEnd, setIndexEnd] = useState(2);
  const location = useLocation();

  const fetchData = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const [music, news, artistic] = await Promise.all([
        ApiService.getMusic(),
        ApiService.getNews(),
        ApiService.getDirectionArtistic(),
      ]);
      const combinedResults = [
        ...music.map((item) => ({
          ...item,
          type: { name: "COMPOSIZIONI", name_eng: "COMPOSITIONS" },
          id: "music" + item.slug,
          originalId: item.slug,
        })),
        ...news.map((item) => ({
          ...item,
          type: { name: "NEWS", name_eng: "NEWS" },
          id: "news" + item.slug,
          originalId: item.slug,
        })),
        ...artistic.map((item) => ({
          ...item,
          type: { name: "DIREZIONE ARTISTICA", name_eng: "ARTISTIC DIRECTION" },
          id: "artistic" + item.id,
          originalId: item.id,
        })),
      ];
      setSearchResults(combinedResults);
    } catch (error) {
      console.error("Errore durante il recupero dei dati:", error);
      setError("Si è verificato un errore durante il recupero dei dati.");
    }
    setIsLoading(false);
  };
  useEffect(() => {
    const query = new URLSearchParams(location.search).get("query");
    if (query) setSearchTerm(query);
  }, [location.search]);
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      handlePageChange(1);
    }
    setFilteredResults(
      searchResults.filter(
        (categoryType) =>
          (categoryType.subcategory !== "Lable" &&
            categoryType.subcategory !== "description" &&
            (!searchTerm.toLowerCase() ||
              categoryType.title
                .toLowerCase()
                .includes(searchTerm.toLowerCase()) ||
              (isEnglish
                ? categoryType.category.name_eng &&
                  categoryType.category.name_eng
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())
                : categoryType.category.name &&
                  categoryType.category.name
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase())) ||
              (categoryType.subcategory &&
                categoryType.category
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())))) ||
          (isEnglish
            ? categoryType.type.name_eng &&
              categoryType.type.name_eng
                .toLowerCase()
                .includes(searchTerm.toLowerCase())
            : categoryType.type.name &&
              categoryType.type.name
                .toLowerCase()
                .includes(searchTerm.toLowerCase()))
      )
    );
  }, [searchTerm, searchResults]);

  const totalPages = Math.ceil(filteredResults.length / 12);
  
  const handlePageChange = (page) => {
    if (page > currentPage && page > 1) {
      window.scrollTo(0, 0);
      if (page > currentPage + 1) {
        setIndexStart(
          indexStart === 0 && indexEnd < 3
            ? 0 + (page - currentPage - 1)
            : indexStart + 1 * (page - currentPage)
        );
        setIndexEnd(indexEnd + 1 * (page - currentPage));
        setStart(start + 12 * (page - currentPage));
        setEnd(end + 12 * (page - currentPage));
      } else {
        setIndexStart(
          indexStart === 0 && indexEnd < 3
            ? 0
            : indexStart + 1 * (page - currentPage)
        );
        setIndexEnd(indexEnd + 1);
        setStart(start + 12);
        setEnd(end + 12);
      }
    } else if (page < currentPage && page < totalPages) {
      if (page < currentPage - 1) {
        setIndexStart(
          indexStart === 0 && indexEnd >= 3
            ? 0
            : indexStart - 1 * (currentPage - 1 - page)
        );
        setIndexEnd(
          indexEnd === totalPages && indexStart < totalPages - 3
            ? totalPages - 1
            : indexEnd - 1 * (currentPage - page)
        );
        setStart(start - 12 * (currentPage - page));
        setEnd(end - 12 * (currentPage - page));
      } else {
        setIndexStart(indexStart === 0 && indexEnd >= 3 ? 0 : indexStart - 1);
        setIndexEnd(
          indexEnd === totalPages && indexStart < totalPages - 3
            ? totalPages - 1
            : indexEnd - 1
        );
        setStart(start - 12);
        setEnd(end - 12);
      }
    }
    setCurrentPage(page);
  };

  if (isLoading) return;

  return (
    <Container fluid className="m-0 padding_custom w-100 h-100">
      <Container>
        <h2 className="text-center section-title mt-5 text-uppercase">
          {isEnglish ? "SEARCH" : "CERCA"}
        </h2>
        <div className="border-custom mt-3"></div>
        <Form
          className="d-flex align-items-center justify-content-center mb-3 mt-5"
          onSubmit={(e) => e.preventDefault()}
        >
          <InputGroup className="form_container mx-2">
            <FloatingLabel controlId="floatingInput" label={isEnglish ? "Search..." : "Cerca..."}>
              <FormControl
                type="text"
                placeholder="Inserisci termine di ricerca"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-dark"
              />
            </FloatingLabel>
          </InputGroup>
        </Form>
        {error && <Alert variant="danger">{error}</Alert>}

        <Row className="d-flex  justify-content-center">
          {filteredResults.slice(start, end).map((filtered) => {
            return (
              <Col className="py-3 container-serch" key={filtered.id}>
                <Link
                  target={
                    filtered.link ??  "_blank"
                  }
                  rel="noreferrer"
                  className="link_color text-dark  text-decoration-none container-serch-element p-2 h-100  d-flex align-items-center justify-content-center"
                  to={`${
                    filtered.link
                      ? filtered.link
                      : filtered.type.name === "COMPOSIZIONI"
                        ? "/compositions/" + filtered.category.name.toLowerCase() + "/" + filtered.originalId
                        : filtered.type.name === "NEWS"
                          ?? "/news/" + filtered.originalId
                  }`}
                  style={{ whiteSpace: "normal", wordBreak: "break-word" }}
                >
                  <div>
                    <p className="text-center title_data">
                      {isEnglish ? filtered.type.name_eng : filtered.type.name}
                    </p>
                    {(filtered.img || filtered.image) && (
                      <div className="my-4">
                        <img
                          src={filtered.img || filtered.image}
                          alt={filtered.name}
                          className="m-0 img_serch"
                        />
                      </div>
                    )}
                    <h5 className="text-center mb-3 text_compositions">
                      {!isEnglish
                        ? filtered.title.charAt(0).toUpperCase() +
                          filtered.title.slice(1).toLowerCase()
                        : filtered.title_eng
                        ? filtered.title_eng.charAt(0).toUpperCase() +
                          filtered.title_eng.slice(1).toLowerCase()
                        : filtered.title.charAt(0).toUpperCase() +
                          filtered.title.slice(1).toLowerCase()}
                    </h5>
                    <div className="w-100 mt-3 p-0 d-flex align-items-center justify-content-center mb-0">
                      <Badge
                        bg=""
                        pill
                        className="badge-text text-center badge_credits p-0 "
                      >
                        <p className="text-center m-0 p-2">
                          {isEnglish
                            ? (filtered.category.name_eng &&
                                filtered.category.name_eng
                                  .charAt(0)
                                  .toUpperCase() +
                                  filtered.category.name_eng
                                    .slice(1)
                                    .toLowerCase()) ||
                              filtered.category
                            : (filtered.category.name &&
                                filtered.category.name.charAt(0).toUpperCase() +
                                  filtered.category.name
                                    .slice(1)
                                    .toLowerCase()) ||
                              filtered.category}
                        </p>
                      </Badge>
                    </div>
                  </div>
                </Link>
              </Col>
            );
          })}
        </Row>

        <Pagination className=" d-flex justify-content-center mt-3 w-100 ">
          <Pagination.First onClick={() => handlePageChange(1)} />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {currentPage > 2 && (
            <>
              <Pagination.Item
                linkClassName={"link-pagination"}
                onClick={() => handlePageChange(1)}
              >
                {1}
              </Pagination.Item>
              <Pagination.Ellipsis />
            </>
          )}
          {[...Array(totalPages).keys()]
            .slice(indexStart, indexEnd)
            .map((page) => (
              <Pagination.Item
                linkClassName={
                  page + 1 === currentPage
                    ? "link-pagination-active"
                    : "link-pagination"
                }
                key={page + 1}
                active={page + 1 === currentPage}
                onClick={() => handlePageChange(page + 1)}
              >
                {page + 1}
              </Pagination.Item>
            ))}
          {currentPage < totalPages - 1 && (
            <>
              <Pagination.Ellipsis />
              <Pagination.Item
                linkClassName={"link-pagination"}
                onClick={() => handlePageChange(totalPages)}
              >
                {totalPages}
              </Pagination.Item>
            </>
          )}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last onClick={() => handlePageChange(totalPages)} />
        </Pagination>
      </Container>
    </Container>
  );
}

export default Search;
